<template>
    <div class="navbar-wrapper px-4 lg:px-12">
        <nav
            class="navbar h-auto lg:h-16 w-full xl:py-3 items-center justify-between z-10 hidden sm:flex sm:flex-col lg:flex-row">
            <div class="flex items-center h-16 sm:justify-between sm:w-full lg:w-auto">
                <i @click="$router.push('/')"
                   class="cursor-pointer">
                    <img :src="getLogo"
                         alt="Logo"
                         class="h-10">
                </i>
                <IconHorisontalLine class="hidden lg:flex mx-4 xl:mx-12"/>
                <DashboardMenu :editMode="editMode" v-if="layoutType === 'activeLayout'" />
                <ManageReports />
                <i class="vc-icon-home icon-lg text-gray-700 cursor-pointer hover:text-primary" v-if="isReportPage" @click="$router.push('/')" />
            </div>
            <div class="flex items-center p-2 sm:justify-between sm:w-full lg:w-auto">
                <div class="mx-4 cursor-pointer flex items-center justify-center relative" v-click-outside="onClickOutsideList">
                    <el-badge :value="soundsLength" class="item"><i @click="changeState" class="vc-icon-notification text-primary-actions icon-xl"></i></el-badge>
                    <div class="absolute main-bg-light p-2 border rounded-md sound-list" v-if="showList && soundsLength">
                        <div class="mb-2 p-2 main-text-color" :class="getClass(sound)" v-for="(sound, index) in sounds" :key="index" v-html="sound.notificationHTML" />
                    </div>
                </div>
                <div v-click-outside="onClickOutsideSound" class="flex items-center justify-center relative cursor-pointer mx-2 sound-block" @mouseenter="volumeTooltip = true">
                    <i
                        @click="operationWithMute"
                        class="vc-icon-sound-off text-primary-actions icon-xl"
                        :class="isMuted ? 'vc-icon-sound-off' : 'vc-icon-sound-low'"
                    />
                    <div
                        class="sound-volume"
                        @mouseleave="volumeTooltip = false"
                        @mouseenter="volumeTooltip = true"
                    >
                        <div
                            class="volume-input-block"
                            v-if="volumeTooltip"
                        >
                            <input
                                v-model="volume"
                                type="range"
                                min="0"
                                max="1"
                                step="0.2"
                                class="range-input"
                                :style="{
                                    backgroundSize: `${volume * 100}% 100%`
                                }"
                            >
                        </div>
                    </div>
            </div>
                <slot name="dashboard-operations"/>
                <div class="flex justify-between w-full items-center" v-if="layoutType === 'activeLayout' || isReportPage">
                    <LanguageSwitcher class="lg:mx-5" />
                    <AccountMenu @currentAccountIdUpdated="currentAccountIdUpdated" />
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import { Badge } from 'element-ui'
    export default {
        components: {
            AccountMenu: () => import('@/components/Navbar/components/AccountMenu'),
            ManageReports: () => import('@/components/Navbar/components/ManageReports'),
            DashboardMenu: () => import('@/components/Navbar/components/DashboardMenu'),
            LanguageSwitcher: () => import('@/components/Navbar/components/LanguageSwitcher'),
            [Badge.name]: Badge
        },
        props: {
            editMode: {
                type: Boolean
            },
            layoutType: {
                type: String
            },
            isReportPage: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                volume: 0.2,
                volumeTooltip: false,
                showList: false
            }
        },
        computed: {
            getTypeOfLayout () {
                return this.$store.getters['layout/getTypeOfLayout']
            },
            getLogo() {
                return this.$store.getters['layout/getLogo'](this.getTypeOfLayout)
            },
            isMuted() {
                return this.$store.getters['sound/isMuted']
            },
            sounds () {
                return this.$store.getters['sound/getSounds']
            },
            soundsLength () {
                return this.$store.getters['sound/getSoundsLength']
            },
        },
        methods: {
            currentAccountIdUpdated (id) {
                this.$emit('currentAccountIdUpdated', id)
            },
            operationWithMute () {
                this.$store.dispatch('sound/operationWithMute', !this.isMuted)
            },
            changeState () {
                this.showList = !this.showList
            },
            onClickOutsideSound () {
                this.volumeTooltip = false
            },
            onClickOutsideList () {
                this.showList = false
            },
            getClass (sound) {
                let cssClass = ''
                if (sound.isPlaying) {
                    cssClass += 'isPlaying'
                }
                if (sound.played) {
                    cssClass += 'played'
                }
                return cssClass
            }
        },
        watch: {
            volume (val) {
                this.$store.dispatch('sound/setVolume', val)
            }
        },
        created() {
            this.volume = this.$store.getters['sound/getVolume']
        }
    }
</script>
<style scoped>
.navbar-wrapper {
    @apply flex w-full;
    box-shadow: 0px 0px 5px #E0E2E5;
    background: var(--mainBgColor-color);
}
</style>

<style lang="scss" scoped>
.wave-form-content :deep(wave) {
  border: none !important;
}

.right-offset {
  @apply mr-3;
}
.left-offset {
  @apply ml-3;
}

[dir=rtl] {
  .right-offset {
    @apply ml-3;
  }
  .left-offset {
    @apply mr-3;
  }
}

.sound-loading {
  @apply px-2 absolute top-0 left-0 flex items-center;
}

.sound-controls {
  @apply flex items-center cursor-pointer;
}

.sound-time-current {
  @apply text-xs w-9;
}

.sound-progress-bar {
  @apply flex-grow flex flex-col items-center justify-center px-2 relative;
}

.sound-duration {
  @apply text-xs w-9 opacity-50;
}

.sound-volume {
  @apply flex items-center mx-3;
    .volume-input-block {
        @apply absolute bg-white flex items-center justify-center border border-ui-lines rounded-md;
        height: 24px;
        width: 80px;
        bottom: -30px;
        left: -40px;
        padding: 4px;
        z-index: 999;
    }
    .range-input {
        -webkit-appearance: none;
        width: 60px;
        height: 4px;
        background: var(--ui-lines);
        border-radius: 5px;
        background-size: 70% 100%;
        background-image: linear-gradient(var(--active-elements), var(--active-elements));
        background-repeat: no-repeat;
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            height: 12px;
            width: 12px;
            border-radius: 50%;
            background: var(--active-elements);
            cursor: pointer;
            box-shadow: 0 0 2px 0 #555;
            transition: background .3s ease-in-out;
            &:hover {
                background-color: var(--active-elements--focus);
            }
        }
        &::-webkit-slider-runnable-track  {
            -webkit-appearance: none;
            box-shadow: none;
            border: none;
            background: transparent;
        }

    }
}
[dir='rtl'] {
    .range-input {
        transform: rotate(180deg);
        background-position: right center;
    }
}
.sound-block {
    width: 20px;
    margin-right: -5px;
}
.sound-list {
    z-index: 2;
    width: 400px;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translate(-50%, 0);
    max-height: 400px;
    overflow-y: auto;
}
.sound-list .played {
    background-color: #bdbfbd;
}
.sound-list .isPlaying {
    background-color: #38cf38;
}
.sound-list div {
    @apply rounded-sm;
}
</style>
